import { useQuery } from "@tanstack/react-query";
import { useUser } from "../../../contexts/UserContext";

interface FamilyActivity {
  memberName: string;
  memberAvatar: string;
  action: string;
  amount: number;
  category: string;
  merchant: string;
  timestamp: Date;
  type: "Income" | "Expense" | "Transfer";
}

export const useFamilyActivity = () => {
  const { currentUser } = useUser();

  return useQuery({
    queryKey: ["familyActivity", currentUser?.uid],
    queryFn: async () => {
      const activities: FamilyActivity[] = [
        {
          memberName: "John Doe",
          memberAvatar: "/avatars/john.jpg",
          action: "made a purchase",
          amount: 89.99,
          category: "Shopping",
          merchant: "Amazon",
          timestamp: new Date(),
          type: "Expense",
        },
        {
          memberName: "Jane Doe",
          memberAvatar: "/avatars/jane.jpg",
          action: "received payment",
          amount: 2500.0,
          category: "Income",
          merchant: "Employer Inc",
          timestamp: new Date(Date.now() - 3600000),
          type: "Income",
        },
        {
          memberName: "Mike Doe",
          memberAvatar: "/avatars/mike.jpg",
          action: "paid bill",
          amount: 150.0,
          category: "Utilities",
          merchant: "Electric Company",
          timestamp: new Date(Date.now() - 7200000),
          type: "Expense",
        },
      ];

      return { activities };
    },
    enabled: !!currentUser?.uid,
    refetchInterval: 30000, // Refresh every 30 seconds
  });
};
